import React from 'react';
import { get, map, isNil, toNumber, has, filter } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { getDisplayValue } from 'resolvers/formatValue';
import { BLANK_VALUE_SYMBOL, DATA_TYPES } from 'constants/common';

const COST_CALCULATION_ENTITY ={
    'default': [ 'rxEstimatedCost', 'shippingCharges', 'balancePayment' ],
    'deductable': [ 'rxEstimatedCost', 'shippingCharges', 'balancePayment', 'cardCharges' ]
};


const resolvePaymentValue = ( value, float ) => {
    if( isNil( value ) || '' === value ) {
        return 0;
    }

    if( isNaN( toNumber( value ) ) ) {
        return 0;
    }

    if( ! isNaN( toNumber( value ) ) && float ) {
        return toNumber( value ).toFixed( 2 );
    }

    if( ! isNaN( toNumber( value ) ) ) {
        return toNumber( value );
    }

    return value;
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { costCalculation as CostCalculation } from 'ui/views/widgets/costCalculation';
 *
 * // render
 * <CostCalculation propName='propValue'/>
 */
export const costCalculation = ( props ) => {

    const list = COST_CALCULATION_ENTITY[ `${props.mode}` ];
    let updatedList = null;

    if( !  get( props, 'flags.displayBalancePayment', true ) ) {
        updatedList = filter( list, _item => {
            return 'balancePayment' !== _item;
        } );
    } else {
        updatedList = list;
    }
    
    let totalPaymentValue = 0;

    if( has( props.fields, 'totalOutstanding' ) ) {

        // calculated for tehe last step of checkout
        totalPaymentValue = totalPaymentValue + resolvePaymentValue( get( props, 'values.rxEstimatedCost', 0 ) );
        totalPaymentValue = totalPaymentValue + resolvePaymentValue( get( props, 'values.shippingCharges', 0 ) );

        // if( 'deductable' === props.mode ) {

            totalPaymentValue = totalPaymentValue + resolvePaymentValue( get( props, 'values.balancePayment', 0 ) );
            totalPaymentValue = totalPaymentValue - resolvePaymentValue( get( props, 'values.cardCharges', 0 ) );
            totalPaymentValue = Math.abs( totalPaymentValue );
            
        // } else {

        //     totalPaymentValue = totalPaymentValue - resolvePaymentValue( get( props, 'values.balancePayment', 0 ) );
        //     totalPaymentValue = Math.abs( totalPaymentValue );
        // }

    } else {

        totalPaymentValue = totalPaymentValue + resolvePaymentValue( get( props, 'values.rxEstimatedCost', 0 ) );
        totalPaymentValue = totalPaymentValue + resolvePaymentValue( get( props, 'values.shippingCharges', 0 ) );
        totalPaymentValue = totalPaymentValue + resolvePaymentValue( get( props, 'values.balancePayment', 0 ) );

    }

    const className = classnames( 'ui-cost-calculation', props.className );
    
    return(
        <div className={ className }>
            <div className='ui-cost-calculation__entities'>

                {/* COST ENTITY  */}
                { map( updatedList, entity => {

                    const fieldData = get( props.fields, `${entity}`, {} );

                    // get class name
                    const _className = classnames( 'ui-cost-calculation__entities__entity', {
                            'ui-cost-calculation__entities__entity--balance': 'balancePayment' === entity,
                            'ui-cost-calculation__entities__entity--deductable': 'cardCharges' === entity
                        }
                    );

                    // check if value is to vbe shown `-` in case of null
                    const showBlankSymbolIfNull = get( fieldData, 'config.showBlankSymbolIfNull', false );
                    const displayValue = ( showBlankSymbolIfNull && isNil( props.values[ entity ] ) ) ? BLANK_VALUE_SYMBOL:  getDisplayValue( { type: DATA_TYPES.CURRENCY, value: props.values[ entity ] } );

                    return (
                        <div key={ entity } className={ _className }>
                            <div className='ui-cost-calculation__entities__entity__title'>
                                { getLabel( props.fields[ entity ].title ) }
                            </div>

                            <div className='ui-cost-calculation__entities__entity__value'>

                                { 'cardCharges' === entity ? (
                                    <>{ `$(${ ( resolvePaymentValue( get( props, 'values.cardCharges', 0 ), true ) ) })`} </>
                                ) : (
                                    displayValue
                                ) }
                            
                            </div>

                        </div>
                    );
                } ) }
            </div>

            <div className='ui-cost-calculation__total'>
                <div className='ui-cost-calculation__total__title'>

                    { has( props.fields, 'totalOutstanding' ) ?

                        getLabel( get( props.fields, 'totalOutstanding.title', {} ) )

                    :
                        getLabel( get( props.fields, 'totalAmount.title', {} ) )
                    }
                    
                </div>
                <div className='ui-cost-calculation__total__value'>
                    { getDisplayValue( { type: DATA_TYPES.CURRENCY, value: totalPaymentValue } ) }
                </div>
            </div>
        </div>
    );
};

// set display name
costCalculation.displayName = 'costCalculation';

// set default props
costCalculation.defaultProps = {
    mode: 'default'
};

// prop types
costCalculation.propTypes = {};

/************************************** */

export const costCalculationPreloader = () => {
    return (
        <div className='ui-cost-calculation-preloader'>
            <div className='ui-cost-calculation-preloader__entities'>
                { map( [ ...Array( 3 ).keys() ], item => {
                    return (
                        <div key={ item } className='ui-cost-calculation-preloader__entities__entity'>
                            <div className='ui-cost-calculation-preloader__entities__entity__title'></div>
                            <div className='ui-cost-calculation-preloader__entities__entity__value'></div>
                        </div>
                    );
                } ) }
                
            </div>
            <div className='ui-cost-calculation-preloader__entities__entity'>
                <div className='ui-cost-calculation-preloader__entities__entity__title'></div>
                <div className='ui-cost-calculation-preloader__entities__entity__value'></div>
            </div>
        </div>
    );
};

// set display name
costCalculationPreloader.displayName = 'costCalculationPreloader';

// set default props
costCalculationPreloader.defaultProps = {};

// prop types
costCalculationPreloader.propTypes = {};
